import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import { Button } from "antd";
import { PageContainer, ProCard, } from '@ant-design/pro-components';
import 'antd/dist/reset.css';
import FormDrawer from "../../components/FormDrawer";
import { CountriesForm } from "./CountriesForm";
import { CountryApi, Configuration, ItemApi, PartyDto } from "../../api/najd";
import CountriesTable from "./CountriesTable";
import { API_URL } from "../../constants";

interface LocationsProps {
    partyInfo: PartyDto;
}
export const Countries: React.FC<LocationsProps> = ({ partyInfo }) => {
    const { t } = useTranslation();
    const [editMode, setEditMode] = useState(false);
    const [drawerOpen, setDrawerOpen] = useState(false);
    const [selectedRowData, setSelectedRowData] = useState<any>(null);
    const [refreshTrigger, setRefreshTrigger] = useState<boolean>(false);

    const configuration = new Configuration({
        basePath: API_URL,
    });

    const countryApi = new CountryApi(new Configuration({basePath: API_URL,}));

    const closeDrawer = () => {
        setDrawerOpen(false);
    };

    const handleRefresh = () => {
        setRefreshTrigger((prevState) => !prevState);
    };

    const onClickCreateNew = () => {
        // Handle create new action
        console.log('Click create new');
        setEditMode(false);
        setSelectedRowData({}); // Set the selected row data in the state
        console.log('set null=>', selectedRowData);
        setDrawerOpen(true);
    };

    const onClickRowEdit = (rowData: any) => {
        // Handle the row edit action
        console.log('Click editing row:', rowData);
        setEditMode(true);
        setSelectedRowData(rowData); // Set the selected row data in the state
        setDrawerOpen(true);
    };

    const onClickSubmitButton = () => {
        // Handle the row edit action
        console.log('=> onClickSubmitButton');
        if (selectedRowData) {
            handleFormSubmit(selectedRowData);
        }
    };
    // const onSubmit = (formData: any) => {
    //     // Handle the row edit action
    //     console.log('On Submit:', formData);
    // };

    // Form Events
    const handleFormSubmit = (formData: any) => {
        // Handle form submission in the parent component
        console.log('Form Data:', formData);
        if (editMode == true) {
            countryApi.countryUpdate(formData.id, formData)
                .then(response => {
                    // Handle the API response
                    console.log('==>categoryGetList');
                    console.log(response.data);
                    closeDrawer();
                    handleRefresh();
                })
                .catch(error => {
                    // Handle the API error
                    console.error(error);
                });
        } else {
            countryApi.countryCreate(formData)
                .then(response => {
                    // Handle the API response
                    console.log('==>categoryGetList');
                    console.log(response.data);
                    closeDrawer();
                    handleRefresh();
                })
                .catch(error => {
                    // Handle the API error
                    console.error(error);
                });
        }
    };
    const handleFormChange = (formData: any) => {
        console.log('handleFormChange:', formData);
        setSelectedRowData(formData);
    };
    // End Form Events
    return (
        <PageContainer
            header={{
                title: t('Countries'),
                ghost: true,
                breadcrumb: {
                    items: [
                        {
                            path: '/',
                            title: t("Configrations"),
                        },
                        {
                            path: '/',
                            title: t("Countries"),
                        },
                    ],
                },
                extra: [
                    (partyInfo.code === 'readonly') ? <></> :<Button key="3" type="primary" onClick={onClickCreateNew}>
                        {t("Add New")}
                    </Button>,
                ],
            }}
        >
            <ProCard
            >
                <CountriesTable
                 partyInfo={partyInfo}
                    onClickRowEdit={onClickRowEdit}
                    refreshTrigger={refreshTrigger}
                    setRefreshTrigger={setRefreshTrigger}
                    />
                <FormDrawer open={drawerOpen}
                    onClose={closeDrawer}
                    formData={selectedRowData}
                    title={((editMode) ? t("Edit") : t("Add New"))}
                    onSubmit={onClickSubmitButton}>
                    <CountriesForm
                        onClose={closeDrawer}
                        formData={selectedRowData}
                        onSubmit={handleFormSubmit}
                        onChange={handleFormChange} />
                </FormDrawer>
            </ProCard>
        </PageContainer>
    );
};
